// extracted by mini-css-extract-plugin
export var card = "_bk-1";
export var container = "_bk-0";